import type IPaginatedResponse from "@fetcher/models/IPaginatedResponse";
import type IPagination from "@fetcher/models/IPagination";
import type { IResponse } from "@fetcher/models/IResponse";
import CRank from "@modules/order/models/CRank";
import type {
  ILoLAccount,
  IRankedInformation,
  IRankedSmurfCardItem,
} from "@modules/ranked/models/IRankedSmurf.models";
import type ISkin from "../../modules/skins/shared/models/ISkin.model";
import LOL_API from "./lolFetcher";

const BASE_URL = "/ranked";

class RankedAPI {
  private static ACCOUNT_PER_PAGE = 12;

  static list = async ({
    page = 1,
    ranks = [],
    price = [],
    skins = [],
  }: {
    page?: number;
    ranks?: string[];
    price?: string[];
    skins?: string[];
  }): Promise<IPaginatedResponse<IRankedSmurfCardItem>> => {
    const res = await LOL_API.get<IPagination<IRankedSmurfCardItem>>(
      `${BASE_URL}`,
      {
        page,
        perPage: RankedAPI.ACCOUNT_PER_PAGE,
        ranks,
        price,
        skins,
      },
    );

    return {
      ...res,
      data: {
        ...res.data,
        data: res.data.data.map((account) => {
          const rankedInformation = JSON.parse(
            account.rankedInformation as unknown as string,
          ) as IRankedInformation;

          return {
            ...account,

            rankedInformation: {
              ...rankedInformation,
              currentRankInformation: new CRank(
                rankedInformation.currentRankInformation,
              ),
              previousRankInformation: new CRank(
                rankedInformation.previousRankInformation,
              ),
              currentFlexRankInformation: new CRank(
                rankedInformation.currentFlexRankInformation,
              ),
            },
          };
        }),
      },
    };
  };

  static skinList = () => LOL_API.get<ISkin[]>(`${BASE_URL}/skins`);

  static get = (puuid: string) =>
    LOL_API.get<ILoLAccount>(`${BASE_URL}/${puuid}`).then((res) => {
      const rankedInformation = JSON.parse(
        res.data.rankedInformation as unknown as string,
      ) as IRankedInformation;

      return {
        ...res,
        data: {
          ...res.data,
          rankedInformation: {
            ...rankedInformation,
            currentRankInformation: new CRank(
              rankedInformation.currentRankInformation,
            ),
            previousRankInformation: new CRank(
              rankedInformation.previousRankInformation,
            ),
            currentFlexRankInformation: new CRank(
              rankedInformation.currentFlexRankInformation,
            ),
          },
        },
      };
    });

  static getWidgetAccounts = (): Promise<IResponse<IRankedSmurfCardItem[]>> => {
    return LOL_API.get<IRankedSmurfCardItem[]>(`${BASE_URL}/home-widget`).then(
      (res) => ({
        ...res,
        data: res.data.map((account) => {
          const rankedInformation = JSON.parse(
            account.rankedInformation as unknown as string,
          ) as IRankedInformation;

          return {
            ...account,

            rankedInformation: {
              ...rankedInformation,
              currentRankInformation: new CRank(
                rankedInformation.currentRankInformation,
              ),
              previousRankInformation: new CRank(
                rankedInformation.previousRankInformation,
              ),
              currentFlexRankInformation: new CRank(
                rankedInformation.currentFlexRankInformation,
              ),
            },
          };
        }),
      }),
    );
  };
}

export default RankedAPI;
